import request from '../../utils/request';

const BASE_URL = process.env.REACT_APP_EXPRESS_URL;

class Api {
  static async getAll(year, team) {
    const url = BASE_URL + '/season/' + year + '/team/' + team + '/team-season-games';
    const response = await request('get', url);
    return response.data;
  }

  static async update(year, team, changedEntries) {
    const url = BASE_URL + '/season/' + year + '/team/' + team + '/team-season-games';
    await request('post', url, { changedEntries });
    return this.getAll(year, team);
  }
}

export default Api;
